import { Grid } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { Loader } from '../../../../../components/Loader';
import { NotFound } from '../../../../../components/NotFound';
import { Page } from '../../../../../layout/Page';
import { useExperienceTemplateById } from '../../../../../services/experiences/template';
import { combineLoadingValues } from '../../../../../services/firebase';
import {
  AnchoredSections,
  AnchorLinks,
  ISection
} from '../../../../layout/AnchoredSection';
import { TopNav } from '../../../../layout/TopNav';
import { useOrgById } from '../../../../services/orgs';
import { OrgNavHeader } from '../../components/OrgNavHeader';
import { Actions } from './components/Actions';
import { AuditLog } from './components/AuditLog';
import { Instances } from './components/Instances';
import { Overrides } from './components/Overrides';
import { Stats } from './components/Stats';
import { Timeline } from './components/Timeline';
import { UpcomingAutomationSchedules } from './components/UpcomingAutomationSchedules';
import { UpcomingSchedules } from './components/UpcomingSchedules';

type Props = {
  orgId: string;
  tplId: string;
};

export const PageOrgExperienceTemplateDetails: React.FC<Props> = ({
  orgId,
  tplId
}) => {
  const [values, loading] = combineLoadingValues(
    useOrgById(orgId),
    useExperienceTemplateById(tplId)
  );
  const [org, tpl] = values || [];

  if (loading) {
    return <Loader />;
  }
  if (!org || !tpl) {
    return <NotFound />;
  }

  const SECTIONS: ISection[] = [
    {
      anchor: 'overrides',
      label: 'Overrides',
      el: <Overrides tpl={tpl} />
    },
    {
      anchor: 'timeline',
      label: 'Timeline',
      el: <Timeline tpl={tpl} org={org} />
    },
    { anchor: 'stats', label: 'Stats', el: <Stats tpl={tpl} /> },
    { anchor: 'instances', label: 'Instances', el: <Instances tpl={tpl} /> },
    {
      anchor: 'schedules',
      label: 'Schedules',
      el: <UpcomingSchedules tpl={tpl} />
    },
    {
      anchor: 'automations',
      label: 'Automations',
      el: <UpcomingAutomationSchedules tpl={tpl} />
    },
    {
      anchor: 'auditLog',
      label: 'Audit Log',
      el: <AuditLog tpl={tpl} />
    },
    {
      anchor: 'actions',
      label: 'Actions',
      el: <Actions tpl={tpl} />
    }
  ];

  return (
    <>
      <TopNav>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <OrgNavHeader
              parts={[
                <Link to={`/orgs/${org.id}`}>{org.data.name}</Link>,
                'Exp Tpl',
                tpl.data.adminTitle || tpl.data.title
              ]}
            />
          </Grid>
        </Grid>
        <AnchorLinks sections={SECTIONS} offset={120} />
      </TopNav>
      <Page style={{ marginTop: 100 }}>
        <AnchoredSections sections={SECTIONS} />
      </Page>
    </>
  );
};
